import { render, staticRenderFns } from "./GrupoVip.vue?vue&type=template&id=2d635456&scoped=true"
import script from "./GrupoVip.vue?vue&type=script&lang=js"
export * from "./GrupoVip.vue?vue&type=script&lang=js"
import style0 from "./GrupoVip.vue?vue&type=style&index=0&id=2d635456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d635456",
  null
  
)

export default component.exports